import { useEffect, useRef, useState, useCallback } from "react";

export function useDocumentTitle(initialTitle: string, delay = 300) {
  const [title, setTitle] = useState(initialTitle);
  const timeoutRef = useRef<number | null>(null);
  const prevTitleRef = useRef(document.title);

  useEffect(() => {
    prevTitleRef.current = document.title;
    document.title = title;
    return () => {
      document.title = prevTitleRef.current;
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  useEffect(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = window.setTimeout(() => {
      document.title = title;
    }, delay);
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [title, delay]);

  const setDocumentTitle = useCallback((newTitle: string) => {
    setTitle(newTitle);
  }, []);

  return setDocumentTitle;
}
